import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';

export function buildLtrtBreadcrumbs({
  vehicle: {
    make: { name: makeName, slug: makeSlug },
    model: { name: modelName, slug: modelSlug },
    submodels: { name: submodelName, slug: submodelSlug },
    year,
  },
  pathname,
  hasVehicleData,
  hasSubmodel,
}) {
  if (!hasVehicleData) {
    return [
      getHomeBreadcrumb(),
      getBaseBreadcrumb('Car Reviews', '/car-reviews/'),
      getBaseBreadcrumb('Long-Term Road Tests', '/car-reviews/long-term-road-tests/'),
      getBaseBreadcrumb(`${year} ${makeName} ${hasSubmodel ? submodelName : modelName}`, pathname),
    ];
  }

  const vehicleBreadcrumbs = [
    getHomeBreadcrumb(),
    getBaseBreadcrumb(makeName, `/${makeSlug}/`),
    getBaseBreadcrumb(`${makeName} ${modelName}`, `/${makeSlug}/${modelSlug}/`),
    getBaseBreadcrumb(`${year} ${makeName} ${modelName}`, `/${makeSlug}/${modelSlug}/${year}/`),
  ];

  if (hasSubmodel) {
    vehicleBreadcrumbs.push(
      getBaseBreadcrumb(`${year} ${makeName} ${submodelName}`, `/${makeSlug}/${modelSlug}/${year}/${submodelSlug}/`)
    );
  }

  return [...vehicleBreadcrumbs, getBaseBreadcrumb('Long Term Road Test', pathname)];
}
